// Component
import Register01App from "./Register-01";

export default function RegisterApp(props) {

    return <Register01App {...props} />;
}